import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    instance as axiosInstance,
    withHeaders,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { JobData } from 'lib';
import { useQuery, UseQueryResult } from 'react-query';

interface UseJobListProps {
    skip: number;
    limit: number;
    days: number;
}

const getQueryData = async (
    url: string,
    token: string
): Promise<AxiosResponse<JobData, any>> => {
    const headers = getDefaultHeaders(token);
    return axiosInstance().get(url, withHeaders(headers));
};

export const useJobList = ({
    skip,
    limit,
    days,
}: UseJobListProps): UseQueryResult<AxiosResponse<JobData, any>, unknown> => {
    const { getToken } = useAuth();
    const url = `/jobs/query/summary?orderBy=jobCreated DESC&daysToReturn=${days}&skip=${skip}&limit=${limit}`;
    return useQuery(
        `job-summary-for-${days}-days-with-skip=${skip}and-limit=${limit}`,
        async () => getQueryData(url, getToken())
    );
};
